import { ChangeDetectionStrategy, Component, OnInit, inject, input, signal } from '@angular/core';

import { Observable } from 'rxjs';

import { IconLibrary } from '@finnairoyj/fcom-ui-styles';

import { CmsArticle } from '@fcom/core-api/';
import { FragmentService } from '@fcom/common/services';
import { ModalButtons } from '@fcom/ui-components';

@Component({
  selector: 'fin-sustainability-trip-message',
  templateUrl: './sustainability-trip-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SustainabilityTripMessageComponent implements OnInit {
  private fragmentService = inject(FragmentService);

  fragmentKey = input.required<string>();

  iconCategory = input(IconLibrary.SVG_LIBRARY);

  linkText = input<string>();

  modalOpen = signal(false);

  tripMessage$: Observable<CmsArticle>;

  readonly ModalButtons = ModalButtons;

  ngOnInit(): void {
    this.tripMessage$ = this.fragmentService.getFragment<CmsArticle>(this.fragmentKey());
  }

  openModal(): void {
    this.modalOpen.set(true);
  }

  closeModal(): void {
    this.modalOpen.set(false);
  }
}
